<span (click)="close()" class="overlay"></span>
